
import React, { Component } from 'react'
// react component used to create a calendar with events on it
// import BigCalendar from "react-big-calendar";
import {
  Calendar,
  // DateLocalizer,
  momentLocalizer,
  // globalizeLocalizer,
  // move,
  // Views,
  // Navigate,
  // components,
} from 'react-big-calendar'
// dependency plugin for react-big-calendar
import moment from "moment";
// react component used to create alerts
import SweetAlert from "react-bootstrap-sweetalert";

// reactstrap components
import { Card, CardBody, Row, Col } from "reactstrap";

import { events } from "variables/general.jsx";

const localizer = momentLocalizer(moment);


class BigCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      events: events,
      alert: null
    };
  }
  selectedEvent = event => {
    alert(event.title);
  };
  addNewEventAlert = slotInfo => {
    console.log(slotInfo)
    this.setState({
      alert: (
        <SweetAlert
          input
          showCancel
          style={{ display: "block" }}
          title="Input something"
          onConfirm={e => this.addNewEvent(e, slotInfo)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
        />
      )
    });
  };
  addNewEvent = (e, slotInfo) => {
    var newEvents = this.state.events;
    newEvents.push({
      title: e,
      start: slotInfo.start,
      end: slotInfo.end
    });
    this.setState({
      alert: null,
      events: newEvents
    });
  };
  hideAlert = () => {
    this.setState({
      alert: null
    });
  };
  eventColors = (event, start, end, isSelected) => {
    var backgroundColor = "event-";
    event.color
      ? (backgroundColor = backgroundColor + event.color)
      : (backgroundColor = backgroundColor + "default");
    return {
      className: backgroundColor
    };
  };
  render() {
    console.log(this.state.events)
    return (
      <>
        <div className="content">
          {this.state.alert}
          <Row>
            <Col className="ml-auto mr-auto" md="10">
              <Card className="card-calendar">
                <CardBody>
                  <Calendar
                    selectable
                    localizer={localizer}
                    events={this.state.events}
                    defaultView="week"
                    scrollToTime={new Date(1970, 1, 1, 6)}
                    defaultDate={new Date()}
                    onSelectEvent={event => this.selectedEvent(event)}
                    onSelectSlot={slotInfo => this.addNewEventAlert(slotInfo)}
                    eventPropGetter={this.eventColors}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default BigCalendar;
